import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"
import * as React from "react"
import { PreferenceOperator } from "./EmailPreferenceCenter"
import Section from "./Section"

type Props = {
  sections: PreferenceCenter["sections"]
} & PreferenceOperator

const Sections: React.FC<Props> = ({ sections, ...props }) => {
  return (
    <>
      {sections.map((section, index) => {
        return (
          <Section
            key={section.id}
            section={section}
            lastSection={index === sections.length - 1}
            {...props}
          />
        )
      })}
    </>
  )
}

export default Sections
